"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconCalendar = void 0;

var React = __importStar(require("react"));

exports.IconCalendar = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return React.createElement("svg", _objectSpread(_objectSpread({
    width: "37",
    height: "37",
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("path", {
    d: "M32.2452 36.9998H3.75732C1.68732 36.9998 0.00108 35.3151 0.00108 33.2436V7.75668C0.00108 5.68527 1.68718 3.999 3.75876 3.999H32.2438C34.3152 3.999 36.0014 5.68509 36.0014 7.75668V33.2436C36.0014 35.315 34.3167 36.9998 32.2452 36.9998V36.9998ZM3.75876 7.00032C3.34109 7.00032 3.00078 7.34063 3.00078 7.7583V33.2452C3.00078 33.6629 3.33969 34.0018 3.75736 34.0018H32.2452C32.6629 34.0018 33.0018 33.6629 33.0018 33.2452V7.7583C33.0018 7.34063 32.6615 7.00032 32.2438 7.00032H3.75876ZM34.501 12.9994H1.50048C0.672192 12.9994 0 12.3272 0 11.4989C0 10.6706 0.672192 9.9984 1.50048 9.9984H34.501C35.3306 9.9984 36.0014 10.6706 36.0014 11.4989C36.0014 12.3272 35.3306 12.9994 34.501 12.9994ZM7.50096 8.49936C6.67267 8.49936 6.00048 7.82717 6.00048 6.99888V2.49888C6.00048 1.67059 6.67267 0.998398 7.50096 0.998398C8.32925 0.998398 9.00144 1.67059 9.00144 2.49888V6.99888C9.00144 7.82717 8.32925 8.49936 7.50096 8.49936ZM28.5019 8.49936C27.6722 8.49936 27.0014 7.82717 27.0014 6.99888V2.49888C27.0014 1.67059 27.6722 0.998398 28.5019 0.998398C29.3316 0.998398 30.0024 1.67059 30.0024 2.49888V6.99888C30.0024 7.82717 29.3316 8.49936 28.5019 8.49936Z",
    fill: color
  }), React.createElement("path", {
    d: "M10.5021 29.5005C10.5021 31.5002 7.50122 31.5002 7.50122 29.5005C7.50122 27.4994 10.5021 27.4994 10.5021 29.5005Z",
    fill: color
  }), React.createElement("path", {
    d: "M10.5021 23.5C10.5021 25.4997 7.50122 25.4997 7.50122 23.5C7.50122 21.5003 10.5021 21.5003 10.5021 23.5Z",
    fill: color
  }), React.createElement("path", {
    d: "M15.0021 29.5005C15.0021 31.5002 12.0012 31.5002 12.0012 29.5005C12.0012 27.4994 15.0021 27.4994 15.0021 29.5005Z",
    fill: color
  }), React.createElement("path", {
    d: "M15.0021 23.5C15.0021 25.4997 12.0012 25.4997 12.0012 23.5C12.0012 21.5003 15.0021 21.5003 15.0021 23.5Z",
    fill: color
  }), React.createElement("path", {
    d: "M15.0021 17.4995C15.0021 19.5006 12.0012 19.5006 12.0012 17.4995C12.0012 15.4998 15.0021 15.4998 15.0021 17.4995Z",
    fill: color
  }), React.createElement("path", {
    d: "M24.0021 29.5005C24.0021 31.5002 21.0012 31.5002 21.0012 29.5005C21.0012 27.4994 24.0021 27.4994 24.0021 29.5005Z",
    fill: color
  }), React.createElement("path", {
    d: "M24.0021 23.5C24.0021 25.4997 21.0012 25.4997 21.0012 23.5C21.0012 21.5003 24.0021 21.5003 24.0021 23.5Z",
    fill: color
  }), React.createElement("path", {
    d: "M24.0021 17.4995C24.0021 19.5006 21.0012 19.5006 21.0012 17.4995C21.0012 15.4998 24.0021 15.4998 24.0021 17.4995Z",
    fill: color
  }), React.createElement("path", {
    d: "M28.5019 23.5C28.5019 25.4997 25.501 25.4997 25.501 23.5C25.501 21.5003 28.5019 21.5003 28.5019 23.5Z",
    fill: color
  }), React.createElement("path", {
    d: "M28.5019 17.4995C28.5019 19.5006 25.501 19.5006 25.501 17.4995C25.501 15.4998 28.5019 15.4998 28.5019 17.4995Z",
    fill: color
  }), React.createElement("path", {
    d: "M19.5021 29.5005C19.5021 31.5002 16.5012 31.5002 16.5012 29.5005C16.5012 27.4994 19.5021 27.4994 19.5021 29.5005Z",
    fill: color
  }), React.createElement("path", {
    d: "M19.5021 23.5C19.5021 25.4997 16.5012 25.4997 16.5012 23.5C16.5012 21.5003 19.5021 21.5003 19.5021 23.5Z",
    fill: color
  }), React.createElement("path", {
    d: "M19.5021 17.4995C19.5021 19.5006 16.5012 19.5006 16.5012 17.4995C16.5012 15.4998 19.5021 15.4998 19.5021 17.4995Z",
    fill: color
  }));
});